/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Helmet } from "react-helmet-async";
import React from "react";

export default function LpExternalLawyerMeta() {
  return (
    <Helmet>
      <title>Partneranwalt werden | Legalbird</title>
      <meta name="description" content="Bewerben Sie sich als Partneranwalt bei Legalbird" />
      <meta name="keywords" content="Partneranwalt, Legalbird, Vertragsrecht, Scheidung, Verkehrsrecht, Familienrecht, Arbeitsrecht" />
      <meta name="robots" content="noindex,nofollow" />
      <meta property="og:title" content="Partneranwalt werden" />
      <meta property="og:locale" content="de_DE" />
      <meta property="og:type" content="website" />
      <meta property="og:description" content="Bewerben Sie sich als Partneranwalt bei Legalbird" />
    </Helmet>
  );
}
